// extracted by mini-css-extract-plugin
module.exports = {"ads":"Dashboard_ads__1CNoc","banner":"Dashboard_banner__iF3C9","desktopBanner":"Dashboard_desktopBanner__1RKJ4","mobileBanner":"Dashboard_mobileBanner__QiBNo"};